import {useEffect, useState, useCallback} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import * as Member from '../../store/ducks/member.duck'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import {StyledTableCell, StyledTableRow} from '.'
import MobileIncentiveTable from './MobileTable'
import TableCellText from './TableCellText'
import Spinner from 'react-bootstrap/Spinner'

export interface Donation {
  sequence: number
  DonationDate: string
  DonationAmount: string
  CheckNumber?: string
  DonationType: string
}

interface SeniorLivingFoundationTableProps {
  displayForMobile?: boolean
}
export default function SeniorLivingFoundationTable({displayForMobile = false}: SeniorLivingFoundationTableProps) {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(Member.actions.fetchSLF())
  }, [dispatch])

  // Map SLF donations to Redux State
  const slf = useSelector((state: any) => state.member.SLF)
  const slfRequestCheck = useSelector((state: any) => state.member.SLFRequestCheck)
  // Check if data still be retrieved
  if (Object.keys(slf).length === 0 && !slfRequestCheck) {
    return (
      <span className='indicator-progress' style={{display: 'block'}}>
        <p className='claim-text mb-5'>
          Please wait while we retrieve your Senior Living Foundation donations... <Spinner animation='border' className='bc-sync-spinner' size='sm' variant='light' />
        </p>
      </span>
    )
  }

  // No data is found
  if (Object.keys(slf).length === 0 && slfRequestCheck) {
    return (
      <p className='claim-text mb-10'>
        <strong>No Senior Living Foundation donations found</strong>
      </p>
    )
  }

  if (displayForMobile) {
    return <MobileIncentiveTable incentiveType='Donation' onClickDownload={undefined} data={slf} />
  }
  return (
    <TableContainer component={Paper}>
      <Table sx={{minWidth: 700}} aria-label='customized table'>
        <TableHead>
          <TableRow>
            <StyledTableCell>Donation Date</StyledTableCell>
            <StyledTableCell>Donation Type</StyledTableCell>
            <StyledTableCell>Check Number</StyledTableCell>
            <StyledTableCell style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>Donation Amount</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {slf &&
            slf.map((row: Donation, i: number) => (
              <StyledTableRow key={i}>
                <StyledTableCell component='th' scope='row'>
                  {row.DonationDate}
                </StyledTableCell>
                <StyledTableCell style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>
                  <TableCellText text={row.DonationType} />
                </StyledTableCell>
                <StyledTableCell style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>
                  <TableCellText text={row.CheckNumber || ''} />
                </StyledTableCell>
                <StyledTableCell style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>
                  <TableCellText text={row.DonationAmount} />
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
